import {
  format as libFormat,
  toDate as libToDate,
  parseISO,
  isWithinInterval,
  addHours,
  isYesterday,
  isToday,
  isThisYear,
  formatDistanceToNowStrict,
} from 'date-fns';

export const toDate = (date) => {
  if (date === undefined) return new Date();
  if (typeof date === 'string') return parseISO(date);

  return libToDate(date);
};

export const format = (_date, _format = 'dd/MM/yyyy') => libFormat(toDate(_date), _format);

export const formatGracefully = (_date) => {
  const date = toDate(_date);

  const interval = { start: addHours(new Date(), -1), end: new Date() };
  if (isWithinInterval(date, interval)) return formatDistanceToNowStrict(date, { addSuffix: true, unit: 'minute' });

  if (isYesterday(date)) return `yesterday at ${format(date, 'HH:mm')}`;
  if (isToday(date)) return `today at ${format(date, 'HH:mm')}`;

  const _format = (isThisYear(date) && 'MMM dd, HH:mm') || 'MMM dd yyyy, HH:mm';

  return `at ${format(date, _format)}`;
};
